import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Template": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const createCertificateTemplateVersion = createAsyncThunk(
    "certificateTemplateVersion/createCertificateTemplateVersion",
    async (templateData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${PUBLIC_BASE_URL}/certificate-template-versions/create-certificate-template-version`,
                templateData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllCertificateTemplateVersions = createAsyncThunk(
    "certificateTemplateVersion/getAllCertificateTemplateVersions",
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-template-versions`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const updateCertificateTemplateVersion = createAsyncThunk(
    "certificateTemplateVersion/updateCertificateTemplateVersion",
    async (templateData, { rejectWithValue }) => {
        try {

            const response = await axios.put(
                `${PUBLIC_BASE_URL}/certificate-template-versions/update-certificate-template-version-info`,
                templateData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getActiveCertificateTemplateVersions = createAsyncThunk(
    "certificateTemplateVersion/getActiveCertificateTemplateVersions",
    async (_, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates/active-certificate-templates`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getCertificateTemplateVersionById = createAsyncThunk(
    "certificateTemplateVersion/getCertificateTemplateVersionById",
    async ({ versionId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-template-versions/${versionId}`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);
